import { MapPin, BadgeCheck, Clock, Globe, MapPinned, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SPORT_ICONS } from "@/data/sports";

const MODE_ICON = { "In-person": MapPinned, Virtual: Globe, Both: Globe };

export function PartnerCard({ partner, onView, onRequest, requested, disabled }) {
  const ModeIcon = MODE_ICON[partner.accountability_mode] || Globe;
  return (
    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/60 p-5 flex flex-col" data-testid={`partner-card-${partner.id}`}>
      <div className="flex items-start gap-4">
        <div className="w-14 h-14 rounded-full overflow-hidden border border-zinc-700 bg-zinc-800 grid place-items-center shrink-0">
          {partner.photo ? <img src={partner.photo} alt={partner.display_name} className="w-full h-full object-cover" /> : <User className="w-6 h-6 text-zinc-500" />}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <h3 className="font-display text-lg font-bold uppercase tracking-tight truncate">{partner.display_name}</h3>
            {partner.verified && <BadgeCheck className="w-4 h-4 text-[#E53E3E] shrink-0" title="Approved partner" />}
          </div>
          <p className="text-xs text-zinc-400 flex items-center gap-1 mt-0.5">
            <MapPin className="w-3 h-3" /> {[partner.city, partner.country].filter(Boolean).join(", ") || "Location not set"}
          </p>
        </div>
      </div>

      {partner.bio && <p className="mt-3 text-sm text-zinc-400 line-clamp-2">{partner.bio}</p>}

      {partner.sports?.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1.5">
          {partner.sports.slice(0, 5).map((s) => {
            const Icon = SPORT_ICONS[s];
            return (
              <span key={s} className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs bg-zinc-800 text-zinc-300 capitalize">
                {Icon && <Icon className="w-3 h-3 text-[#E53E3E]" />} {s.replace("-", " ")}
              </span>
            );
          })}
        </div>
      )}

      <div className="mt-3 space-y-1 text-xs text-zinc-500">
        {partner.accountability_mode && <p className="flex items-center gap-1.5"><ModeIcon className="w-3.5 h-3.5 text-[#E53E3E]" /> {partner.accountability_mode}</p>}
        {partner.availability?.length > 0 && <p className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-[#E53E3E]" /> {partner.availability.join(", ")}</p>}
      </div>

      <div className="mt-4 pt-4 border-t border-zinc-800 flex gap-2">
        <Button variant="outline" size="sm" onClick={() => onView(partner)} className="flex-1 border-zinc-700 bg-transparent hover:bg-zinc-800 rounded-full" data-testid={`partner-view-${partner.id}`}>View Profile</Button>
        <Button size="sm" onClick={() => onRequest(partner)} disabled={requested || disabled} className="flex-1 bg-[#E53E3E] hover:bg-[#C53030] rounded-full disabled:opacity-50" data-testid={`partner-request-${partner.id}`}>
          {requested ? "Requested" : "Send Request"}
        </Button>
      </div>
    </div>
  );
}
